let price = require('../../actions/prices');
let error = require('../../actions/error');

module.exports = {
    getPrices: [
        price.getPrices,
        {
            success: [
                price.setPrices
            ],
            error: [
                error.internalError('price.getPrices')
            ]
        }
    ],

    setComputedFields: [
        price.setComputedFields
    ],

    getColumns: [
        price.getColumns,
        {
            success: [
                price.setColumns
            ],
            error: [
                error.internalError('price.getColumns')
            ]
        }
    ],
};



// WEBPACK FOOTER //
// ./signals/groups/prices.js